/* eslint-disable jsx-a11y/anchor-is-valid */
/**
 * The global Footer, displays a link to the website and the current Keystone
 * version in use
 */

import React from 'react'
import styled from 'styled-components'
import dayjs from 'dayjs'

const Footer = () => {
  const appVersion = localStorage.getItem('version')

  return (
    <StyledFooter>
      <div>
        {appVersion?.split('release-')?.[1] || appVersion}
      </div>
      <div>{`${dayjs().year()} © LMC Software Ltd. All rights reserved.`}</div>
      <div>
        Registered address: Lion Court, 25 Procter Street, London, WC1V 6NY
      </div>
      <StyledLink
        target="_blank"
        href="https://www.logmycare.co.uk/policies/general-data-protection-regulation-gdpr"
        rel="noreferrer"
      >
        Data Policy
      </StyledLink>
      |
      <StyledLink
        target="_blank"
        href="https://logmycare.co.uk/privacy-policy-carehome"
        rel="noreferrer"
      >
        Privacy Policy
      </StyledLink>
      |
      <StyledLink
        target="_blank"
        href="https://www.logmycare.co.uk/policies/terms-and-conditions"
        rel="noreferrer"
      >
        Terms & Conditions
      </StyledLink>
    </StyledFooter>
  )
}

const StyledFooter = styled.footer`
  background-color: #333;
  color: #999;
  font-size: 0.85rem;
  padding-bottom: 25px;
  padding-top: 20px;
  text-align: center;
`

const StyledLink = styled.a`
  padding: 5px;
  color: #999;
  &:hover,
  &:focus {
    color: #ccc;
    outline: none;
  }
`

export default Footer
